"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asNumber = exports.guessType = void 0;
const guessType = value => {
    if (Array.isArray(value)) {
        return 'array';
    }
    if (typeof value === 'string') {
        return 'string';
    }
    if (value === null) {
        return 'null';
    }
    if (typeof value === 'boolean') {
        return 'boolean';
    }
    if (!Number.isNaN(value)) {
        return 'number';
    }
    if (typeof value === 'object') {
        return 'object';
    }
    // Default to string if we can't figure it out
    return 'string';
};
exports.guessType = guessType;
const asNumber = value => {
    if (value === '') {
        return undefined;
    }
    if (/\.$/.test(value)) {
        // "3." can't really be considered a number even if it parses in js. The
        // user is most likely entering a float.
        return value;
    }
    if (/\.0$/.test(value)) {
        // we need to return this as a string here, to allow for input like 3.07
        return value;
    }
    const n = Number(value);
    const valid = typeof n === 'number' && !Number.isNaN(n);
    if (/\.\d*0$/.test(value)) {
        // It's a number, that's cool - but we need it as a string so it doesn't screw
        // with the user when entering dollar amounts or other values (such as those with
        // specific precision or number of significant digits)
        return value;
    }
    return valid ? n : value;
};
exports.asNumber = asNumber;
//# sourceMappingURL=utils.js.map